import React, { Component } from "react";
import { Col, Row, Container, Card, CardHeader, Button } from "reactstrap";

// import RequestManager from "../../singletons/RequestManager/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import LoadingOverlay from "react-loading-overlay";

const everyhour = [
  moment().startOf("day").add(1, "hours"),
  moment().startOf("day").add(2, "hours"),
  moment().startOf("day").add(3, "hours"),
  moment().startOf("day").add(4, "hours"),
  moment().startOf("day").add(5, "hours"),
  moment().startOf("day").add(6, "hours"),
  moment().startOf("day").add(7, "hours"),
  moment().startOf("day").add(8, "hours"),
  moment().startOf("day").add(9, "hours"),
  moment().startOf("day").add(10, "hours"),
  moment().startOf("day").add(11, "hours"),
  moment().startOf("day").add(12, "hours"),
  moment().startOf("day").add(13, "hours"),
  moment().startOf("day").add(14, "hours"),
  moment().startOf("day").add(15, "hours"),
  moment().startOf("day").add(16, "hours"),
  moment().startOf("day").add(17, "hours"),
  moment().startOf("day").add(18, "hours"),
  moment().startOf("day").add(19, "hours"),
  moment().startOf("day").add(20, "hours"),
  moment().startOf("day").add(21, "hours"),
  moment().startOf("day").add(22, "hours"),
  moment().startOf("day").add(23, "hours"),
];
const every2hour = [
  moment().startOf("day").add(2, "hours"),
  moment().startOf("day").add(4, "hours"),
  moment().startOf("day").add(6, "hours"),
  moment().startOf("day").add(8, "hours"),
  moment().startOf("day").add(10, "hours"),
  moment().startOf("day").add(12, "hours"),
  moment().startOf("day").add(14, "hours"),
  moment().startOf("day").add(16, "hours"),
  moment().startOf("day").add(18, "hours"),
  moment().startOf("day").add(20, "hours"),
  moment().startOf("day").add(22, "hours"),
];
const every4hour = [
  moment().startOf("day").add(4, "hours"),
  moment().startOf("day").add(8, "hours"),
  moment().startOf("day").add(12, "hours"),
  moment().startOf("day").add(16, "hours"),
  moment().startOf("day").add(20, "hours"),
];
const every6hour = [
  moment().startOf("day").add(6, "hours"),
  moment().startOf("day").add(12, "hours"),
  moment().startOf("day").add(18, "hours"),
];
const onceaday = [moment().startOf("day").add(0, "hours")];

const DateByMode = [
  "Every 1 Hour",
  "Every 2 Hour",
  "Every 4 Hour",
  "Every 6 Hour",
  "Once a Day",
];

export default class DeliverySchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().startOf("day").add(1, "hours"),
      endDate: moment().startOf("day").add(1, "hours"),
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      pageText: "Delivery schedule",
      DateByMode: DateByMode,
      spinnerLoading: false,
      selectedDateByModeValue: everyhour,
      selectedDateByMode: "Every 1 Hour",
    };
  }

  componentDidMount() {
    document
      .getElementsByTagName("input")[0]
      .setAttribute("readonly", "readonly");
    this.checkLoginMode();
  }

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };
  handleStartDateChange = (date) => {
    this.setState({
      startDate: date,
    });
    console.log("startDate", this.state.startDate);
  };
  handleBookingStartDateChange = (date) => {
    this.setState({
      bookingStartDate: date,
    });
    console.log("startDate", this.state.startDate);
  };
  handleBookingEndDateChange = (date) => {
    if (
      Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.bookingStartDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          bookingEndDate: date,
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("bookingEndDate 2" + date);
      this.setState({
        bookingEndDate: date,
      });
    }
  };
  handleEndDateChange = (date) => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date,
        });

        console.log("endDate 1" + date.format("MM/DD/YYYY"));
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      console.log("endDate 2" + date);
      this.setState({
        endDate: date,
      });
    }
  };

  render() {
    const { spinnerLoading } = this.state;

    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{this.state.pageText}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <select
                          onChange={(value) => {
                            this.onChangeMode(value);
                          }}
                          style={{
                            borderColor: "grey",
                            borderWidth: 2,
                            margin: 10,
                            padding: 5,
                          }}
                        >
                          {this.state.DateByMode.map((data) => {
                            return <option value={data}>{data}</option>;
                          })}

                          {/* <option value="CASH">CASH</option> */}
                        </select>
                      </Col>
                    </Row>

                    <Row>
                      <div
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <p> Start Date</p>
                        <DatePicker
                          selected={this.state.startDate}
                          minDate={moment().endOf("day")}
                          dateFormat="DD/MM/YYYY HH:mm"
                          id="input"
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={60}
                          includeTimes={this.state.selectedDateByModeValue}
                          timeCaption="Time"
                          readonly
                          onChange={this.handleStartDateChange}
                        />
                        <div style={{ marginTop: 15, marginBottom: 15 }}>
                          <p> End Date</p>
                          <DatePicker
                            selected={this.state.endDate}
                            minDate={moment().endOf("day")}
                            dateFormat="DD/MM/YYYY HH:mm"
                            id="input"
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={60}
                            includeTimes={this.state.selectedDateByModeValue}
                            timeCaption="Time"
                            readonly
                            onChange={this.handleEndDateChange}
                          />
                        </div>
                        <Button
                          style={{ marginLeft: 20 }}
                          onClick={() => {
                            this.getOrders();
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    </Row>
                  </Container>
                </CardHeader>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }

  onChangeMode = (event) => {
    this.setState({
      selectedDateByMode: event.target.value,
      selectedDateByModeValue: this.getDateByMode(event.target.value),
    });

    console.log("value", event.target.value);
  };
  getDateByMode = (value) => {
    switch (value) {
      case "Every 1 Hour":
        return everyhour;
      case "Every 2 Hour":
        return every2hour;
      case "Every 4 Hour":
        return every4hour;
      case "Every 6 Hour":
        return every6hour;
      case "Once a Day":
        return onceaday;

      default:
        return everyhour;
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/DeliverySchedule/DeliverySchedule.js